module.exports = __webpack_public_path__ + "static/media/BrianCarter.f5bce4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2019-speakers/BrianCarter.png
// module id = 835
// module chunks = 0